import { render, staticRenderFns } from "./v-take-photo-dailog.vue?vue&type=template&id=1b4ebb5c&scoped=true&"
import script from "./v-take-photo-dailog.vue?vue&type=script&lang=js&"
export * from "./v-take-photo-dailog.vue?vue&type=script&lang=js&"
import style0 from "./v-take-photo-dailog.vue?vue&type=style&index=0&id=1b4ebb5c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4ebb5c",
  null
  
)

export default component.exports